var React = require('react');

function ShopGlass (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"shop-glass"),React.createElement("path",{"d":"M288 230.4v64h151.040c-15.36 89.6-87.040 153.6-176.64 153.6-104.96 0-192-87.040-192-192s87.040-192 192-192c53.76 0 99.84 23.040 133.12 58.88l46.080-46.080c-46.080-46.080-107.52-76.8-179.2-76.8-140.8 0-256 115.2-256 256s115.2 256 256 256 243.2-115.2 243.2-256v-25.6h-217.6z","key":1})]);
}

ShopGlass.defaultProps = {"version":"1.1","width":"512","height":"512","viewBox":"0 0 512 512"};

module.exports = ShopGlass;

ShopGlass.default = ShopGlass;
